import { useState } from "react";

import { isEmpty, isUndefined, omitBy, snakeCase } from "@s-libs/micro-dash";

import useRestQuery from "@/remoteState/useRestQuery";

const getSearchParams = (controls, defaultSortBy, defaultPayload) => {
  const { pageIndex, pageSize, sortBy, attempts, globalFilter = {} } = controls;
  const sorts = isEmpty(sortBy) ? defaultSortBy : sortBy;
  const payload = omitBy(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      sort: sorts
        .map((sort) => `${sort.desc ? "-" : ""}${snakeCase(sort.id)}`)
        .join(","),
      attempts,
      q: globalFilter.searchBoxFilterValue,
      ...defaultPayload,
    },
    isUndefined,
  );
  return new URLSearchParams(payload);
};

const getShouldResetPage = (
  { globalFilter = {} },
  { globalFilter: tableGlobalFilter = {} },
) => {
  return (
    globalFilter.searchBoxFilterValue !== tableGlobalFilter.searchBoxFilterValue
  );
};

const useTableRestQuery = (
  url,
  defaultPageSize,
  defaultSortBy,
  defaultPayload = {},
  skip = false,
) => {
  const [controls, setControls] = useState({
    pageIndex: 0,
    pageSize: defaultPageSize,
    sortBy: [],
    attempts: 1,
  });
  const [rawProps, setRawProps] = useState({});
  const payload = getSearchParams(controls, defaultSortBy, defaultPayload);

  const response = useRestQuery(`${url}?${payload.toString()}`, { skip });

  const fetch = (tableControls = controls, tableProps = rawProps) => {
    const shouldResetPage = getShouldResetPage(controls, tableControls);

    tableProps.gotoPage?.(shouldResetPage ? 0 : tableControls.pageIndex);

    setControls({ ...tableControls, attempts: controls.attempts + 1 });
    setRawProps(tableProps);
  };

  return [response, fetch, controls];
};

export default useTableRestQuery;
